<template>
  <div class="spinner-wrapper">
    <div class="spinner"></div>
  </div>
</template>

<style lang="scss" scoped>
.spinner-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4rem 0;
}

.spinner {
  position: relative;
  width: 3rem;
  height: 3rem;

  &:before {
    content: '';
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    border-top: 0.3rem solid var(--primary-color);
    border-right: 0.3rem solid transparent;
    animation: spin 0.6s linear infinite;
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
